import { render, staticRenderFns } from "./platform-preview.vue?vue&type=template&id=412a0435&scoped=true&"
import script from "./platform-preview.vue?vue&type=script&lang=js&"
export * from "./platform-preview.vue?vue&type=script&lang=js&"
import style0 from "./platform-preview.vue?vue&type=style&index=0&id=412a0435&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412a0435",
  null
  
)

export default component.exports